import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';

const s = {
  page: { minHeight: '100vh', background: '#ffffff' },
  hero: { padding: '4rem 2rem', textAlign: 'center', maxWidth: '600px', margin: '0 auto' },
  badge: {
    display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
    background: 'rgba(58,125,0,0.1)', border: '1px solid rgba(58,125,0,0.3)',
    color: '#3a7d00', padding: '0.35rem 1rem', borderRadius: '100px',
    fontSize: '0.8rem', fontWeight: 600, letterSpacing: '0.05em',
    textTransform: 'uppercase', marginBottom: '1.5rem',
  },
  h1: { fontFamily: 'Inter, ui-sans-serif, sans-serif', fontWeight: 800, fontSize: 'clamp(2rem, 4vw, 3rem)', letterSpacing: '-0.03em', marginBottom: '1rem', lineHeight: 1.1, color: '#111111' },
  grad: { background: 'linear-gradient(135deg, #3a7d00, #1f4500)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' },
  sub: { color: '#666680', fontSize: '1rem', lineHeight: 1.6, marginBottom: '0.5rem' },
  free: { color: '#3a7d00', fontSize: '0.85rem', fontWeight: 500, marginBottom: '2.5rem' },
  section: { maxWidth: '700px', margin: '0 auto', padding: '0 2rem 4rem' },
  tabs: { display: 'flex', background: '#f0f0f0', borderRadius: '12px', padding: '4px', marginBottom: '2rem' },
  tab: (active) => ({
    flex: 1, padding: '0.65rem 1rem', borderRadius: '8px', textAlign: 'center',
    fontWeight: 600, fontSize: '0.9rem', cursor: 'pointer', transition: 'all 0.2s',
    background: active ? '#ffffff' : 'transparent',
    border: active ? '1px solid rgba(0,0,0,0.08)' : 'none',
    color: active ? '#111111' : '#666680',
  }),
  uploadBox: {
    border: '2px dashed rgba(0,0,0,0.12)', borderRadius: '16px',
    padding: '3rem 2rem', textAlign: 'center', cursor: 'pointer',
    transition: 'all 0.2s', background: '#f8f8f8', marginBottom: '1.5rem',
  },
  uploadIcon: { fontSize: '3rem', marginBottom: '1rem' },
  uploadTitle: { fontFamily: 'Inter, ui-sans-serif, sans-serif', fontWeight: 700, fontSize: '1.1rem', marginBottom: '0.5rem', color: '#111111' },
  uploadSub: { color: '#666680', fontSize: '0.9rem', marginBottom: '1.5rem' },
  uploadBtn: {
    padding: '0.75rem 2rem', borderRadius: '10px',
    background: 'linear-gradient(135deg, #3a7d00, #1f4500)',
    color: '#fff', fontWeight: 600, fontSize: '0.95rem', border: 'none', cursor: 'pointer',
  },
  orDivider: { textAlign: 'center', color: '#aaa', margin: '1.25rem 0', fontSize: '0.85rem' },
  textArea: {
    width: '100%', minHeight: '120px', padding: '1rem',
    background: '#f8f8f8', border: '1px solid rgba(0,0,0,0.08)',
    borderRadius: '12px', color: '#111111', fontSize: '0.9rem',
    outline: 'none', resize: 'vertical', lineHeight: 1.6,
  },
  generateBtn: {
    width: '100%', marginTop: '1rem', padding: '0.85rem',
    borderRadius: '12px', background: 'linear-gradient(135deg, #3a7d00, #1f4500)',
    color: '#fff', fontWeight: 600, fontSize: '1rem', border: 'none', cursor: 'pointer',
  },
  proBox: {
    background: 'rgba(58,125,0,0.05)',
    border: '1px solid rgba(58,125,0,0.2)',
    borderRadius: '16px', padding: '1.5rem', marginTop: '1.5rem', textAlign: 'center',
  },
  proTitle: { fontFamily: 'Inter, ui-sans-serif, sans-serif', fontWeight: 700, fontSize: '1rem', marginBottom: '0.5rem', color: '#111111' },
  proSub: { color: '#666680', fontSize: '0.85rem', marginBottom: '1rem' },
  proBtn: {
    padding: '0.65rem 1.5rem', borderRadius: '8px',
    background: 'linear-gradient(135deg, #3a7d00, #1f4500)',
    color: '#fff', fontWeight: 600, fontSize: '0.9rem', border: 'none', cursor: 'pointer',
  },
};

export default function EatIn({ user }) {
  const navigate = useNavigate();
  const [tab, setTab] = useState('scan');
  const [ingredients, setIngredients] = useState('');
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [recipes, setRecipes] = useState(null);

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (file) setImage(URL.createObjectURL(file));
  };

  const handleGenerate = async () => {
    if (!user) { navigate('/auth'); return; }
    setLoading(true);
    setTimeout(() => {
      setRecipes([
        { name: 'High-Protein Chicken Bowl', calories: 420, protein: 45, carbs: 32, fat: 12, time: '20 min' },
        { name: 'Quick Veggie Stir Fry', calories: 280, protein: 18, carbs: 38, fat: 8, time: '15 min' },
      ]);
      setLoading(false);
    }, 2000);
  };

  return (
    <div style={s.page}>
      <Navbar user={user} />
      <div style={s.hero}>
        <div style={s.badge}>🏠 Eat In</div>
        <h1 style={s.h1}>Your Personal <span style={s.grad}>Kitchen Assistant</span></h1>
        <p style={s.sub}>Scan your ingredients, get macro-friendly recipes, and cook delicious meals at home.</p>
        <p style={s.free}>✨ Try it free — no signup required for your first recipe!</p>
      </div>

      <div style={s.section}>
        <div style={s.tabs}>
          <div style={s.tab(tab === 'scan')} onClick={() => setTab('scan')}>📷 Scan Ingredients</div>
          <div style={s.tab(tab === 'type')} onClick={() => setTab('type')}>✏️ Generate Recipes</div>
        </div>

        {tab === 'scan' ? (
          <>
            {image ? (
              <div style={{ marginBottom: '1.5rem', borderRadius: '16px', overflow: 'hidden', border: '1px solid rgba(0,0,0,0.08)' }}>
                <img src={image} alt="Ingredients" style={{ width: '100%', maxHeight: '300px', objectFit: 'cover' }} />
                <div style={{ padding: '1rem', background: '#f8f8f8', display: 'flex', gap: '1rem' }}>
                  <button style={{ flex: 1, padding: '0.65rem', borderRadius: '8px', background: 'transparent', border: '1px solid rgba(0,0,0,0.12)', color: '#666680', fontSize: '0.85rem', cursor: 'pointer' }} onClick={() => setImage(null)}>Remove Photo</button>
                  <button style={{ flex: 2, padding: '0.65rem', borderRadius: '8px', background: 'linear-gradient(135deg, #3a7d00, #1f4500)', color: '#fff', fontWeight: 600, fontSize: '0.85rem', border: 'none', cursor: 'pointer' }} onClick={handleGenerate}>{loading ? 'Analyzing...' : 'Identify & Generate Recipes'}</button>
                </div>
              </div>
            ) : (
              <label style={s.uploadBox}
                onMouseEnter={e => e.currentTarget.style.borderColor = '#3a7d00'}
                onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(0,0,0,0.12)'}
              >
                <input type="file" accept="image/*" style={{ display: 'none' }} onChange={handleUpload} />
                <div style={s.uploadIcon}>📸</div>
                <div style={s.uploadTitle}>Scan Your Fridge & Pantry</div>
                <div style={s.uploadSub}>Take a photo of your fridge, pantry, or ingredients to automatically identify them for recipe generation.</div>
                <div style={s.uploadBtn}>↑ Upload Photo</div>
              </label>
            )}
          </>
        ) : (
          <>
            <textarea
              style={s.textArea}
              placeholder="List your ingredients... e.g. chicken breast, broccoli, brown rice, olive oil, garlic"
              value={ingredients}
              onChange={e => setIngredients(e.target.value)}
            />
            <button style={s.generateBtn} onClick={handleGenerate}>
              {loading ? '⏳ Generating...' : '✨ Generate Macro-Friendly Recipes'}
            </button>
          </>
        )}

        {recipes && (
          <div style={{ marginTop: '2rem' }}>
            <div style={{ fontFamily: 'Inter, ui-sans-serif, sans-serif', fontWeight: 700, fontSize: '1.1rem', marginBottom: '1rem', color: '#111111' }}>Your Recipes</div>
            {recipes.map((r, i) => (
              <div key={i} style={{ background: '#f8f8f8', border: '1px solid rgba(0,0,0,0.08)', borderRadius: '14px', padding: '1.25rem', marginBottom: '1rem' }}>
                <div style={{ fontWeight: 700, fontSize: '1rem', marginBottom: '0.75rem', color: '#111111' }}>{r.name}</div>
                <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap' }}>
                  {[['🔥', r.calories, 'cal'],['💪', `${r.protein}g`, 'protein'],['🌾', `${r.carbs}g`, 'carbs'],['💧', `${r.fat}g`, 'fat'],['⏱️', r.time, '']].map(([icon, val, label]) => (
                    <div key={label} style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: '0.75rem', color: '#666680', marginBottom: '2px' }}>{icon} {label}</div>
                      <div style={{ fontWeight: 700, color: '#111111' }}>{val}</div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        {!user && (
          <div style={s.proBox}>
            <div style={s.proTitle}>🚀 Unlock Unlimited Recipes</div>
            <div style={s.proSub}>Sign up free to save your recipes, track macros over time, and get personalized recommendations.</div>
            <button style={s.proBtn} onClick={() => navigate('/auth')}>Get Started Free</button>
          </div>
        )}
      </div>
    </div>
  );
}